"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n_en_us = void 0;
function i18n_en_us() {
    return {
        "languages.de": "German",
        "languages.en": "English",
        "languages.it": "Italian",
        "languages.pl": "Polish",
        "languages.es": "Spanish",
        "languages.fr": "French",
        "languages.pt": "Portuguese",
        "languages.nl": "Dutch",
        "languages.cs": "Czech",
        "languages.hr": "Croatian",
        "languages.ja": "Japanese",
        "countries.de": "Germany",
        "countries.ch": "Switzerland",
        "countries.at": "Austria",
        "countries.gb": "Great Britain",
        "countries.en": "Great Britain",
        "countries.us": "United States",
        "countries.it": "Italy",
        "countries.pl": "Poland",
        "countries.es": "Spain",
        "countries.fr": "France",
        "countries.pt": "Portugal",
        "countries.nl": "Netherlands",
        "countries.be": "Belgium",
        "countries.lu": "Luxembourg",
        "countries.cz": "Czech Republic",
        "countries.hr": "Croatia",
        "countries.sk": "Slovakia",
        "countries.no": "Norway",
        "countries.se": "Sweden",
        "countries.fi": "Finland",
        "countries.dk": "Denmark",
        "countries.ie": "Ireland",
        "countries.ca": "Canada",
        "countries.au": "Australia",
        "countries.nz": "New Zealand",
        "countries.mx": "Mexico",
        "countries.br": "Brazil",
        "countries.jp": "Japan"
    };
}
exports.i18n_en_us = i18n_en_us;
